import React, { Component } from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import domain from '../domain'
import axios from 'axios'
import { MDBInput } from "mdbreact";
import moment from 'moment'
import { FadeLoader } from "react-spinners";
/**
 *  Home Page Popup Modal
 */

import colors from "../colors";
import ReactHTMLParser from "react-html-parser";
class DownloadModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableDownload: false,
      purpose: null,
      organization: null,
      check: false,
      agency: null,
      stateinfo: null,
      disabled: false,
      country: null,
      loading: false,
      enableothers:false,
    }
  }



  save = () => {
    const url = `${domain.DBServer}/save-user-download-data`
    const data = {
      theme: 'VIC',
      product: this.props.product,
      subproduct: null,

      purpose: this.state.purpose,
      user: this.props.user,
    }
    axios.request({
      method: 'post',
      url: url,
      data: data,
    }).then((result) => {
      if (result) {
        console.log(result.data)
        if (result.data) {
          console.log(result.data)
          let requestid = result.data.requestid
          if (requestid !== null) {
            this.handleDownloadLink()
          }
        }
      }
    })
  }
  onSubmit = async (e) => {
    console.log(this.state)
    e.preventDefault();
    if (this.state.purpose !== null) {
      this.save()
    }




  }
  handleDownloadLink = () => {
    this.setState({
      loading: true
    })
    const method = 'POST';
    let product
    if (this.props.product === 'Surface Runoff') {
      product = 'RO'
    }
    else if (this.props.product === 'Evapotranspiration') {
      product = "ET"
    }
    else if (this.props.product === 'Upper-Layer Soil Moisture') {
      product = 'USM'
    }
    else if (this.props.product === 'Root Zone Soil Moisture') {
      product = 'RSM'
    }

    const url = `${domain.Fileserver}/download_multiple`
    axios
      .request({
        url,
        method,
        data: {
          theme: 'VIC',
          product: product,
          d1: this.props.d1,
          d2: this.props.d2,
          user: this.props.user
        },
        responseType: 'blob', //important
      })
      .then((result) => {
        if (result) {
          this.setState({
            loading: false
          })
          console.log(result)
          const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', `NHP_NRSC_VIC_${product}_${this.props.d1}_${this.props.d2}.zip`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.props.toggle()
        }
      });
  };

  handleCheck = (e) => {
    this.setState({
      check: e.target.value,
      disabled: true,

    })
  }
  changeAgency = (e) => {
    this.setState({
      agency: e.target.value
    })
  }
  changeState = (e) => {
    this.setState({
      stateinfo: e.target.value
    })
  }
  changeOrg = (e) => {
    this.setState({
      organization: e.target.value
    })
  }
  changePurpose = (e) => {
    this.setState({
      purpose: e.target.value
    })
  }
  changePurpose_multiple=(e)=>{
    if(e.target.value!=='1')
    {
      let value = Array.from(e.target.selectedOptions, option => option.value);
      this.setState({ purpose: value,enableothers:false });

    }
    else{
      this.setState({
        enableothers:true,
        purpose:null
      })
    }
  }
  render() {
    // console.log(this.props)
    return (
      <MDBContainer >
        {/* <MDBBtn color="primary" onClick={this.toggle(14)}>MDBModal</MDBBtn> */}
        <MDBModal
          isOpen={this.props.modal}
          toggle={this.props.toggle}
          centered
          backdrop={false}
          size="lg"
        //     style={{
        //   textAlign: "justify",
        //   width: window.innerWidth<1000?"250px":"600px",

        //   overflow: "scroll",
        // }}
        >
          <MDBModalHeader
            className="text-center"
            titleClass="w-100 font-weight-bold"
            toggle={this.props.toggle}
            style={{ background: "#3f51b5", color: "white" }}
          >
            {this.props.title}
          </MDBModalHeader>
          <MDBModalBody
            style={{
              textAlign: "justify",
              height: window.innerHeight > 1000 ? "500px" : "300px",

              overflow: "scroll",
            }}
          >
            <form onSubmit={this.onSubmit}>

              {/* <div class="form-group row">
                <label for="inputcountry" class="col-sm-2 col-form-label">Country</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="inputcountry" placeholder="Country" pattern="[a-zA-Z 0-9]+" minlength="4" maxlength="1000" required value={this.state.country} onChange={this.changeCountry} />
                </div>
              </div>

              <div class="form-group row">
                <label for="inputstate" class="col-sm-2 col-form-label">State</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="inputstate" placeholder="State" pattern="[a-zA-Z 0-9]+" minlength="4" maxlength="1000" required value={this.state.stateinfo} onChange={this.changeState} />
                </div>
              </div>
              <div class="form-group row">
                <label for="inputorg" className="col-sm-2 col-form-label">Organization</label>
                <div class="col-sm-10">
                  <input type="text" className="form-control" id="inputorg" placeholder="Organization" pattern="[a-zA-Z 0-9]+" minlength="4" maxlength="1000" required value={this.state.org} onChange={this.changeOrg} />
                </div>
              </div>
              <div class="form-group row">
                <label for="inputagency" class="col-sm-2 col-form-label">Agency</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="inputagency" placeholder="Agency" pattern="[a-zA-Z 0-9]+" minlength="4" maxlength="1000" required value={this.state.agency} onChange={this.changeAgency} />
                </div>
              </div> */}

         

              <div class="form-group row">
                <label for="inputpurpose" class="col-sm-3 col-form-label">Purpose
                <span style={{ color: "red" }}> &nbsp;
                    *(<i>Use Ctrl + left click or mouse dragging for multiple selections</i>)
                  </span></label>
                <div class="col-sm-8">
                  {this.props.product === 'Surface Runoff' ?
                    <select 
                    multiple="true"
                    className="custom-select"
                    name="hd"
                    id="hd" onChange={this.changePurpose_multiple} required>
                      <option value='Water Availability Assessment'>Water Availability Assessment</option>
                      <option value='Water Resources Planning and Management'>Water Resources Planning and Management</option>
                      <option value='Hydrological modelling'>Hydrological modelling</option>
                      <option value='Climate Change impact assessment'>Climate Change impact assessment</option>
                      <option value='Hydrological Drought  '>Hydrological Drought  </option>
                    
                      <option value="1">Others (please specify)</option>
                    </select>


                    :this.props.product==='Evapotranspiration'?
                    <select
                    multiple="true"
                    className="custom-select"
                    name="hd"
                    id="hd" onChange={this.changePurpose_multiple} required>


                      <option value='	Irrigation Management '>	Irrigation Management</option>
                      <option value='Crop Water Requirement'>Crop Water Requirement</option>
                      <option value='Hydrologic cycle '>Hydrologic cycle</option>
                      <option value='	Climate change impact assessment'>	Climate change impact assessment</option>

                      <option value='1'>Others (please specify)</option>
                    </select> :this.props.product==='Upper-Layer Soil Moisture'?
                      <select
                      multiple="true"
                      className="custom-select"
                      name="hd"
                      id="hd"  onChange={this.changePurpose_multiple} required>


                        <option value='Irrigation Demand Estimation '>Irrigation Demand Estimation</option>
                        <option value='Agricultural/Hydrological Drought'>Agricultural/Hydrological Drought</option>
                        <option value='Water balance '>Water balance</option>
                      <option value='Soil Erosion'>Soil Erosion</option>
                        <option value='1'>Others (please specify)</option>
                      </select>: <select
                    multiple="true"
                    className="custom-select"
                    name="hd"
                    id="hd"  onChange={this.changePurpose_multiple} required>
                      <option value='	Irrigation Demand Estimation'>	Irrigation Demand Estimation</option>
                      <option value='	Agricultural/Hydrological Drought '>	Agricultural/Hydrological Drought </option>
                      <option value='	Water balance  '>	Water balance  </option>
                      <option value='Soil Erosion'>Soil Erosion</option>
                     
                    
                      <option value="1">Others (please specify)</option>
                    </select>

                  }
                  <br/>   <br/>
                  {
                    this.state.enableothers  ? <input type="text" onChange={this.changePurpose} value={this.state.purpose} required /> : null
                  }
                  {/* <textarea className="form-control" id="inputpurpose" rows="5" value={this.state.purpose}
                    pattern="[a-zA-Z 0-9]+" minlength="25" maxlength="1000" onChange={this.changePurpose} required ></textarea> */}
                </div>
               
              </div>
              <div class="form-group row col-sm-12 justify-content-center">
              <div className="custom-control custom-checkbox pl-3">
                <input
                  className="custom-control-input"
                  type="checkbox"
                  value={this.state.check}
                  disabled={this.state.disabled}
                  id="invalidCheck"
                  required
                  onChange={this.handleCheck}
                />
                <label className="custom-control-label" htmlFor="invalidCheck">
                  I hereby agree to cite the usage of this product in the reports/publications appropriately.
  
              </label>

              </div>
              </div>
              <div class="form-group row justify-content-center">
                <div class="col-sm-12">
                  <p>Citation:</p>
                  <p style={{ textAlign: "justify" }}>NRSC, 2021, {this.props.product}, Geospatial hydro products developed by National Remote Sensing Centre under National Hydrology Project,&nbsp;
                  <a href={`${domain.bhuvannhpurl}`}>{domain.bhuvannhpurl}</a>, Last accessed:&nbsp;{moment(new Date()).format("DD-MMM-YYYY")}</p>
                </div>
              </div>
              <div class="form-group row d-flex justify-content-center">

                <button type="submit" class="btn btn-primary text-capitalize" size="sm">Download</button>



                {
                  this.state.loading ?
                    <div className="sweet-loading">
                      <FadeLoader
                        sizeUnit={"px"}
                        color={"#123abc"}
                        loading={this.state.loading}
                      />
                    </div> : null
                }

              </div>





              {/* <MDBInput label="Organization" background size="lg" required onChange={this.handleOrganization}/>
Purpose

<input type="submit"/> */}
            </form>


            {/* {this.state.enableDownload ?
              <button type="submit" class="btn btn-primary text-capitalize" size="sm"  onClick={this.handleDownloadLink}>
            <a onClick={this.handleDownloadLink}>Download</a></button> :

              null} */}
          </MDBModalBody>

        </MDBModal>
      </MDBContainer>
    );
  }
}

export default DownloadModal;
